import { useEffect } from 'react';

import { FormikProps } from 'formik';

import { getLongTermContractAttributes } from '@pharmaplan/common';
import { getDaysDistribution } from '@pharmaplan/common/helpers/utils';
import { useAppSelector } from '../useAppSelector';

const useSyncMultiHours = (formik: FormikProps<any>) => {
  const longAttributes = useAppSelector(getLongTermContractAttributes);
  const { shiftContractAttributes } = longAttributes ?? {};

  useEffect(() => {
    const { weekdayHours, weekendHours } = getDaysDistribution(
      shiftContractAttributes,
    );

    formik.setFieldValue('weekdayHours', weekdayHours);
    formik.setFieldValue('weekendHours', weekendHours);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shiftContractAttributes]);
};

export default useSyncMultiHours;
